import { render } from "./LandscapingDataSourceEditCard.vue?vue&type=template&id=54b5312e&scoped=true"
import script from "./LandscapingDataSourceEditCard.vue?vue&type=script&lang=js"
export * from "./LandscapingDataSourceEditCard.vue?vue&type=script&lang=js"

import "./LandscapingDataSourceEditCard.vue?vue&type=style&index=0&id=54b5312e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b5312e"]])

export default __exports__